/* eslint-disable jira/integration/test-id-by-folder-structure */
import React from 'react';
import Inline from '@atlaskit/primitives/inline';
import Stack from '@atlaskit/primitives/stack';
import { xcss } from '@atlaskit/primitives/xcss';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import { TabContainer } from './TabContainer.tsx';

export const PlaybookLogsLoadingView = (): React.JSX.Element => (
	<TabContainer>
		<Stack
			testId="playbooks-list-screen.ui.playbook-logs.edge-cases.loading"
			space="space.250"
			grow="fill"
			xcss={wrapperStyles}
		>
			<Inline spread="space-between">
				<Skeleton height={32} width={240} borderRadius={token('radius.small')} isShimmering />
				<Skeleton height={32} width={40} borderRadius={token('radius.small')} isShimmering />
			</Inline>
			<Stack space="space.100">
				<LoadingRow />
				<LoadingRow />
				<LoadingRow />
			</Stack>
		</Stack>
	</TabContainer>
);

const LoadingRow = () => (
	<Inline space="space.100">
		<Skeleton height={32} width="22%" borderRadius={token('radius.small')} isShimmering />
		<Skeleton height={32} width="16%" borderRadius={token('radius.small')} isShimmering />
		<Skeleton height={32} width="16%" borderRadius={token('radius.small')} isShimmering />
		<Skeleton height={32} width="16%" borderRadius={token('radius.small')} isShimmering />
		<Skeleton height={32} width="10%" borderRadius={token('radius.small')} isShimmering />
		<Skeleton height={32} width="10%" borderRadius={token('radius.small')} isShimmering />
		<Skeleton height={32} width="10%" borderRadius={token('radius.small')} isShimmering />
	</Inline>
);

const wrapperStyles = xcss({
	paddingTop: 'space.300',
});
